const EDIT_PANEL_SCOPE = {
  TITLE: 'name',
  DESCRIPTION: 'description',
  SHIPPING_WINDOW: 'shippingWindow',
  CUSTOMIZATION: 'customization',
  COLLECTION: 'collectionIds',
};

const EDIT_PANEL_EVENT_TYPE = {
  ADD: 'add',
  REMOVE: 'delete',
  REPLACE: 'replace',
  BEGINNING: 'beginning',
  END: 'end',
};

const ADDONS = {
  DUMMY: 'dummy',
  ESSENTIAL: 'essential',
  PRODUCT_BULK_EDIT: 'product-bulk-edit',
  SALESPERSON: 'salesperson',
  SHIPPING: 'shipping',
  PROMOTIONS: 'promotions',
};

const PRICE_MODEL = {
  FREE: 'free',
  ONE_TIME_PURCHASE: 'one-time_purchase',
  CONTINUES_SUBSCRIPTION: 'continues_subscription',
};

const BILLING_CYCLE = {
  ANNUALLY: 'annually',
  MONTHLY: 'monthly',
};

const SUBSCRIPTION_ACTION = {
  APPLY: 'apply',
  CANCEL: 'cancel',
  CHANGE_PLAN: 'change_plan',
};

export {
  ADDONS,
  PRICE_MODEL,
  BILLING_CYCLE,
  SUBSCRIPTION_ACTION,

  // product bulk edit
  EDIT_PANEL_SCOPE,
  EDIT_PANEL_EVENT_TYPE,
};

export const EDIT_PANEL_SCOPE_KEYS = Object.keys(EDIT_PANEL_SCOPE);
export const EDIT_PANEL_EVENT_TYPE_KEYS = Object.keys(EDIT_PANEL_EVENT_TYPE);
